import { render, staticRenderFns } from "./OrderExchangeConfirm.vue?vue&type=template&id=6175ae48&scoped=true"
import script from "./OrderExchangeConfirm.vue?vue&type=script&lang=js"
export * from "./OrderExchangeConfirm.vue?vue&type=script&lang=js"
import style0 from "./OrderExchangeConfirm.vue?vue&type=style&index=0&id=6175ae48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6175ae48",
  null
  
)

export default component.exports